import googleMapsApi from 'google-maps-api';

export default function initGoogleMaps() {
	const applicationData = document.querySelectorAll("[data-select='googleMaps']");
	const defaultMapOptions = {
		zoom: 13
	};

	if (applicationData) {
		applicationData.forEach(function(element) {
			var map = null;
			var geo = null;

			const data = JSON.parse(element.textContent);
			const identifier = data['identifier'];
			const latitude = parseFloat(data['latitude']);
			const longitude = parseFloat(data['longitude']);
			const name = data['name'];

			const mapContainer = document.getElementById(identifier);
			const apiKey = mapContainer.getAttribute("data-apiKey");
			const api = googleMapsApi(apiKey);

			const addressText = data['addressText'];

			var mapOptions = Object.assign(defaultMapOptions,{});


			var head = document.getElementsByTagName('head')[0];
			var insertBefore = head.insertBefore;
			head.insertBefore = function (newElement, referenceElement) {
				if (newElement.href && newElement.href.indexOf('//fonts.googleapis.com/css?family=') > -1) {
					return;
				}
				insertBefore.call(head, newElement, referenceElement);
			};

			if (data && mapContainer && longitude && latitude) {
				api().then(function() {
					// init map
					if (latitude && longitude) {
						mapOptions.center = {lat: latitude, lng: longitude};
					}

					map = new google.maps.Map(mapContainer, mapOptions);
				}).then(function() {
					//add markers
					const marker = new google.maps.Marker({
						position:  {lat: latitude, lng: longitude},
						map: map,
						title: name
					});

					// add content info window
					const contentString = '<div>' + name + '</div>';
					const infowindow = new google.maps.InfoWindow({
						content: contentString
					});
					google.maps.event.addListener(marker, 'click', function() {
						infowindow.open(map, marker);
					});
					infowindow.open(map, marker);
				}).done();
			} else if (data && mapContainer && addressText) {
				api().then(function() {
					geo = new google.maps.Geocoder();
					geo.geocode({
						'address': addressText
					}, function (results, status) {
						if (status == 'OK') {
							const geoResult = results[0].geometry.location;

							map = new google.maps.Map(mapContainer, mapOptions);
							map.setCenter(geoResult);

							var marker = new google.maps.Marker({
								map: map,
								position: geoResult
							});

							const contentString = '<div>' + name + '</div>';
							const infowindow = new google.maps.InfoWindow({
								content: contentString
							});
							google.maps.event.addListener(marker, 'click', function() {
								infowindow.open(map, marker);
							});
							infowindow.open(map, marker);
						}
					});
				});
			}
		});
	}
}

initGoogleMaps();
